module.exports = __webpack_public_path__ + "static/media/feelingProud.da8af35d.svg";